// ===========================================================================
// Care Management System — por ahora solo el submódulo patient-profiles.
//
// DEV-ONLY: el módulo resuelve su propio gating y en producción NO publica
// rutas (ver common/constants.js). El sidebar usa la misma constante, así que
// las dos caras no pueden desincronizarse.
// ===========================================================================
import { lazy } from "react";
import { PATIENT_PROFILES_ENABLED } from "./common/constants";

const PatientProfilesPage = lazy(() =>
  import("./patient-profiles/pages/PatientProfilesPage")
);

export const careManagementSystemRoutes = PATIENT_PROFILES_ENABLED
  ? [{ path: "/patient-profiles", element: <PatientProfilesPage /> }]
  : [];

export { PatientProfilesPage };
export { PATIENT_PROFILES_ENABLED, PATIENT_PROFILES_BASE_PATH } from "./common/constants";
